import React, { Fragment, useContext, useRef, useState } from 'react';
import moment from 'moment';
import Spinner from './spinner';
import { GlobalContext } from '../../context/Provider';

const DownloadFileModal = ({ exportData }: any) => {
    const { authState, language_data } = useContext(GlobalContext);

    const today = moment().format('YYYY-MM-DD');

    const [startDate, setStartDate] = useState<string>(
        moment().subtract(10, 'days').format('YYYY-MM-DD')
    );
    const [endDate, setEndDate] = useState<string>(
        moment().format('YYYY-MM-DD')
    );

    const btnRef = useRef(null) as React.MutableRefObject<any>;
    const [loading, setLoading] = useState(false);

    const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // allow clear
        if (!value) {
            setStartDate('');
            return;
        }

        // prevent future date
        if (value > today) return;

        setStartDate(value);

        // if end date is before new start date, update end date
        if (endDate && endDate < value) {
            setEndDate(value);
        }
    };

    const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        // allow clear
        if (!value) {
            setEndDate('');
            return;
        }

        // prevent future date
        if (value > today) return;

        // prevent end date before start date
        if (startDate && value < startDate) return;

        setEndDate(value);
    };

    const exportNow = async () => {
        if (!startDate || !endDate) return;
        if (startDate > today) return;
        if (endDate > today) return;
        if (endDate < startDate) return;

        setLoading(true);
        await exportData(
            moment(startDate, 'YYYY-MM-DD').startOf('day').valueOf(),
            moment(endDate, 'YYYY-MM-DD').endOf('day').valueOf()
        );
        setLoading(false);
        btnRef?.current.click();
    };

    return (
        <Fragment>
            <div
                className="modal fade"
                id="fileDownloadModal"
                tabIndex={-1}
                aria-labelledby="fileDownloadModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <h5 className="modal-title fs-5 d-block w-100 text-center" id="exampleModalLabel">
                                {language_data?.[authState.lang]?.common_download} {language_data?.[authState.lang]?.common_records}
                            </h5>
                            <div className="close-modal-button">
                                <button
                                    type="button"
                                    ref={btnRef}
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                        </div>

                        <div className="modal-body form-fields-box">
                            <div className="row">
                                {/* From Date */}
                                <div className="col-md-6">
                                    <label className="fw-semibold">
                                        {language_data?.[authState.lang]?.common_from} {language_data?.[authState.lang]?.common_date}
                                    </label>
                                    <input
                                        type="date"
                                        name="start_date"
                                        className="form-control rounded-0"
                                        value={startDate}
                                        max={today}
                                        onChange={handleStartDateChange}
                                    />
                                </div>

                                {/* To Date */}
                                <div className="col-md-6">
                                    <label className="fw-semibold">
                                        {language_data?.[authState.lang]?.common_to} {language_data?.[authState.lang]?.common_date}
                                    </label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        className="form-control rounded-0"
                                        value={endDate}
                                        min={startDate || undefined}
                                        max={today}
                                        onChange={handleEndDateChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-white bg-danger text-white m-0 me-3"
                                data-bs-dismiss="modal"
                                disabled={loading}
                            >
                                {language_data?.[authState.lang]?.common_cancel}
                            </button>

                            <button
                                className="btn btn-theme m-0"
                                type="button"
                                onClick={exportNow}
                                disabled={loading || !startDate || !endDate}
                            >
                                {loading ? (
                                    <Spinner color="text-white" />
                                ) : (
                                    language_data?.[authState.lang]?.common_download
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default React.memo(DownloadFileModal);